import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable()
export class AuthService {
  state: number;
  isSmallDevice: boolean = true;
  notify: string = "";
  menuImage: string = localStorage.getItem("menuImage");
  //databaseURL: string = "http://localhost/diplomka/src/app/dbscripts/";
  databaseURL: string = "http://betterme.cz/dbscripts/";


  constructor(private router: Router) {
    if(window.screen.width > 1200) this.isSmallDevice = false;
    if(localStorage.getItem("isLogged") == "Of course! :)"){
      this.state = 2;
    }
    else{
      this.state = 0;
    }
   }

  login(){
    if(this.state == 0){
      this.state++;
      
      localStorage.setItem("isLogged","Of course! :)");
      this.router.navigate(['home']);

      location.reload();
      this.state++;
    }
    
  }
  logout(){
    this.state = 0;
    localStorage.clear();
    this.router.navigate(['']);
  }

  redirectToHome(){
    this.router.navigate(['home']);
  }

  redirectToGroups(){
    this.router.navigate(['contacts']);
  }
  
}



// WEBPACK FOOTER //
// ./src/app/services/auth.service.ts